import type { EventData } from "@/features/map/hooks/events/types";

/**
 * Check if the shift key is pressed.
 * @param eventData - The event data object.
 * @returns True if the shift key is pressed, false otherwise.
 */
export const isShiftPressed = (eventData: EventData) => {
  return eventData?.originalEvent?.shiftKey;
};

/**
 * Check if the left click is pressed.
 * @param eventData - The event data object.
 * @returns True if the left click is pressed, false otherwise.
 */
export const isLeftClick = (eventData: EventData | MouseEvent) => {
  const mouseEvent =
    eventData instanceof MouseEvent ? eventData : eventData?.originalEvent;
  return mouseEvent?.button === 0;
};

/**
 * Check if the right click is pressed.
 * @param eventData - The event data object.
 * @returns True if the right click is pressed, false otherwise.
 */
export const isRightClick = (eventData: EventData | MouseEvent) => {
  const mouseEvent =
    eventData instanceof MouseEvent ? eventData : eventData?.originalEvent;
  return mouseEvent?.button === 2;
};
